import DateWindowsField from '../DateWindowsField';
import BlackoutDatesField from '../BlackoutDatesField';

interface Props {
  disabled: boolean;
}

export default function DatesStep({ disabled }: Props) {
  return (
    <div className="space-y-4">
      <DateWindowsField disabled={disabled} />

      <BlackoutDatesField disabled={disabled} />
    </div>
  );
}
